import React, { Component } from 'react';
import FloatingButtons from './FloatingButtons';
import { Background, Top, Bottom, Mask } from './styles';
import Snackbar from 'material-ui/Snackbar';
import Modal from './Modals';
import BreakOutMode from '../BreakOutMode/BreakOutMode';
import Janus from '../../lib/janus'
import UTIL from '../../lib/util'
import { netlifyDebug, webrtcLog, localDebug, setRecord, getConfInfo, checkRoomState, hangupConf, checkPlatform, ALertHeaderText, bitrate_const, bitrate_const_index, checkPremiumRoom, isWebinar, isSpacee, checkDevice, checkStorageDevice, getChromeVersion, gerAudioOutputDevice, checkRoomExists, isFVlite, checkDomainExpire, isSentry, checkMobile , isSafari, isSentryBreadcrumbs } from '../../lib/lib'
import sdpUtil from '../../lib/sdpUtil'
import { database, firestore } from '../../lib/firebase'
import md5 from 'md5'
import hark from  'hark'
import LoggedInLayout from '../../layouts/LoggedIn/AppBar';
import config from '../../config/config'
import { FormattedMessage } from 'react-intl';
import Dialog from 'material-ui/Dialog';
import TextField from 'material-ui/TextField';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import UncheckedRadioButton from 'material-ui/svg-icons/toggle/radio-button-unchecked';
import RaisedButton from 'material-ui/RaisedButton';
import 'moment-timezone/builds/moment-timezone-with-data-2012-2022';
import moment from 'moment-timezone';
import VideoView from './VideoView';
import ScreenShare from '../../lib/screenshare';
import io from 'socket.io-client';
import PQueue from '../../lib/p-queue';
import NotificationSystem from 'react-notification-system';
import putBlobInDb from '../../lib/IndexedDB';
import { convertMinutesToSeconds, onRecordRelatedMessage } from '../../lib/recordHelpers';

const raiseHandAudioFile = require('../../audio/GameShowWin.wav')
const joinAudioFile = require('../../audio/OpentheWindow.wav')
const audio = new Audio(raiseHandAudioFile);
const joinAudio = new Audio(joinAudioFile);
let iceServers = [
  {urls: "stun:" + config.TURN_HOST +":"+ 443},
  {urls: "turn:" + config.TURN_HOST +":"+ 443 + "?transport=udp", credential: 'test', username: 'test' },
  {urls: "turn:" + config.TURN_HOST +":"+ 443 + "?transport=tcp", credential: 'test', username: 'test' }
]

const queue = new PQueue({concurrency: 1})
let janus
let sfutest
let sfutest1
let speechEvents
let mouseMoveSetTimeout
class SeminarMode extends Component {
  constructor(props) {
    super(props);
    this.notificationSystem = React.createRef();
    this.refLeaveMember = null
    this.refLeaveGroup = null
    this.refLeaveRaise = null
    this.recordingLimit = convertMinutesToSeconds(30);
    this.state = {
      snackbarOpen: false,
      snackbarMessage: '',
      listModalOpen: true,
      listModalPurpose: "loading",
      name: "",
      notify_count: 0,
      initialize: false,
      room: "",
      role: "",
      email: "",
      conference_id: "",
      conference_name: "",
      conference_description: "",
      user_id: "",
      user_uid: "",
      group: 0,
      audio_group: {},
      screen_publish_state: false,
      screen_publish_state_init: false,
      muteVideo: false,
      muteAudio: false,
      get_device: false,
      set_device_audio: false,
      set_device_video: false,
      audio_device: [],
      audio_output_array: [],
      video_device: [],
      audio_device_value_index: 0,
      audio_output_device_value_index: 0,
      video_device_value_index: 0,
      raise: false,
      raise_disable: false,
      chat: [],
      mode: "",
      hear: {},
      blockFeed: false,
      bitrate_index: 2,
      selectedOption: "teacher",
      mouseMoveSetTimeout: null,
      buttonDisplay: true,
      anonymous: false,
      mobile: false,
      turn: false,
      unix_time: "",
      direct: false,
      stream: null,
      p2pScreenShareId: null,
      isOpenDrawer: false,
      sessionsPremiumRoom: false,
      videoBandwidth: 3,
      isCountStart: false,
      disabledAudioPermission: false,
      disabledVideoPermission: false,
      isRecording: false,
      recordingKey: null,
      tabTitle: document.title,
      codec: "h264",
      databaseMembers: {},
      recordingTime: 0,
    }

    this.memberRef = null
    this.unsubscribeDatabaseMembers = null

    var chat = {}
    for (var i = 100 - 1; i >= 0; i--) {
      chat[i]=[]
    }
    this.state.chat = chat
    //P2P
    this.refRoom1 = null
    this.refRoom2 = null
    this.refPeer1 = null
    this.refPeer2 = null
    this.pcBitrateIndex = {}
    this.pcPeers = {}
    this.pcScreenPeers = {}
    this.pcScreenMyPeers = {}
    this.socket = null
    this.roomName = null
    this.localStream = null
    this.streamScreen = null
    this.chunks = [];
    this.stream = null;
    this.recordingStream = null;
    this.mediaRecorder = null;
    this.ss = null 
    this.recording = null;
    this.ss = null
    this.recordingDesktopId = null;
    this.videoFinderTimer = null;
    const params = new URLSearchParams(this.props.api.location.search);

    checkPlatform()
    // サービスごとの初期条件

    if( !isWebinar() ){
      // P2P
      let videoBandwidthIndex = localStorage.getItem('p2pVideoBandwidthIndex')
      if(videoBandwidthIndex){
        if(videoBandwidthIndex > 3){ // 後方互換
          this.state.bitrate_index = 2
        }else{
          this.state.bitrate_index = videoBandwidthIndex
        }
        this.state.videoBandwidth = bitrate_const[this.state.bitrate_index].bitrate / 1000
      }else{
        this.state.videoBandwidth = bitrate_const[this.state.bitrate_index].bitrate / 1000
      }
    } else {
      // webinr
      this.state.name = UTIL.makeid()
      
      if ( !params.get('token')){
          alert("無効なURLです")
          window.location = config.WEBINAR_ADMIN_URL
      }
      getConfInfo(params.get('token')).then( y => {
        if (y["admin"] == "yes") {
          this.state.listModalOpen = false
          this.state.anonymous = true
          this.setState({
            conference_id: y["conference_id"],
            user_id: y["user_id"],
            conference_name: y["conference_name"],
            conference_description: y["conference_description"],
            bitrate_index: bitrate_const_index[y["bit_rate"]],
            mobile: y["mobile"],
            turn: y['turn'],
            codec: y['codec'],
            direct: true
          })
        }else if(y["admin"] == "no"){
          this.setState({
            conference_id: y["conference_id"],
            user_id: y["user_id"],
            role: y["role"],
            conference_name: y["conference_name"],
            conference_description: y["conference_description"],
            bitrate_index: bitrate_const_index[y["bit_rate"]],
            mobile: y["mobile"],
            turn: y['turn'],
            codec: y['codec'],
            direct: false
          })
          this.state.anonymous = false
          this.onEnterRoom(this.state.anonymous)
        }
      })
    }
  }

  static _displayMediaConstraints = {
    video: true,
  }

  static errors = {
    cancelled: 'Not allowed',
  }

  static essentials = {
    recordTabTitle: '録画するために、ここを選択してください。',
  }

  async componentDidMount(){
        
    // audio output
    let skinId;
    skinId = await gerAudioOutputDevice(localStorage.getItem('audioOutputDeviceId'));
    this.videoFinderTimer = setInterval(() => {
      const element = document.querySelector('video');
      if (element !== undefined && element !== null) {
        this.changeAudioOutPut(skinId);
        clearInterval(this.videoFinderTimer);
      }
    }, 1500);


    if(isFVlite()){
      try{
      this.roomName = this.props.api.location.pathname.replace(/\//g,'')
      if (window.location.hostname != "localhost" && !localDebug() && !netlifyDebug()){
        const domain_check = await checkDomainExpire(); 
        if(domain_check.errors) {
          alert("ドメインが見つかりません")
          if(config.API_HOST == "workshop.tokyo"){
            window.location = "https://admin.lfv.jp/"
          }else{
            window.location = "https://admin-dev.lfv.jp/"
          }
          return
        }    
        if(domain_check.data && domain_check.data.expire){
          alert("ドメインは期限切れです")
          if(config.API_HOST == "workshop.tokyo"){
            window.location = "https://admin.lfv.jp/"
          }else{
            window.location = "https://admin-dev.lfv.jp/"
          }
          return
        }  
        const room_check = await checkRoomExists(this.roomName) // TODO: room check for the domain
        if(room_check.errors){
          alert("部屋は存在しません")
          if(config.API_HOST == "workshop.tokyo"){
            window.location = "https://admin.lfv.jp/"
          }else{
            window.location = "https://admin-dev.lfv.jp/"
          }
          return
        }
      }

      if (window.location.hostname == "localhost" || localDebug() || netlifyDebug()){
        this.roomName = 'video-dev' + '.' + this.roomName
      }else{
        var full = window.location.host
        var parts = full.split('.')
        var sub = parts[0]
        this.roomName = sub + "." + this.roomName
      }
      this.prepareP2P()
      return
      }
      catch(error){
        const message = "room and domain isfvlite() failed"
        isSentryBreadcrumbs(error,message)
      }
    }


    if(!isWebinar()){
      this.roomName = this.props.api.location.pathname.replace(/\//g,'')
      if(isSpacee()){
        this.prepareP2P()
        this.roomName = this.roomName + "spaceeversion"
        return
      }
      const r = await checkPremiumRoom(this.roomName)
      if(r.data){
        this.setState({ sessionsPremiumRoom: true })
        if(r.data.sfu){
          alert("SFUはサービス終了しました。")
        }else{
          this.prepareP2P()
          console.log("p2p in premium")
        }
      }else{
        this.prepareP2P()
        console.log("p2p in free")
      }
      setTimeout(()=>{this.onEnterRoom(this.state.anonymous)}, 1500)
    }

    if(isWebinar() && this.state.anonymous){
      this.nameInput.focus();
    }
 
  }

  componentDidUpdate(prevProps, prevState) {
    const { isRecording } = this.state
    if (isRecording !== prevState.isRecording) {
      if (isRecording) {
        window.onbeforeunload = function (e) {
          // Cancel the eventy
          e.preventDefault();
          window.postMessage({ type: "stopScreenRecording", desktopId: this.recordingDesktopId });
        }
      } else {
        window.onbeforeunload = null;
      }
    }
  }
  componentWillUnmount() {
    window.onbeforeunload = null;
  }
  async startScreenCapture() {
    let captureStream = false;
    if (navigator.getDisplayMedia) {
      try {
        captureStream = await navigator.getDisplayMedia(SeminarMode._displayMediaConstraints);
      } catch(err) {
        captureStream = SeminarMode.errors.cancelled;
        const message = "screen startScreenCapture() failed"
        isSentryBreadcrumbs(err,message)
      }
    } else if (navigator.mediaDevices.getDisplayMedia) {
      try {
        captureStream = await navigator.mediaDevices.getDisplayMedia(SeminarMode._displayMediaConstraints);
      } catch(err) {
        captureStream =  SeminarMode.errors.cancelled;
        const message = "screen startScreenCapture() failed"
        isSentryBreadcrumbs(err,message)
      }
    }
    return captureStream;
  }

  // Get the video stream
  async getScreenStream() {
    let stream;
    // For Plugin support
    if (!this.isChromeCompatible()) {
      this.ss = ScreenShare.create({ debug: false });
      var result = this.ss.isScreenShareAvailable();
      if(!result) {
        this.setState({ listModalOpen: true, listModalPurpose: "plugin" });
        return;
      };
      stream = await this.ss.start({
        frameRate: 6,
      });
    } else {
      stream = await this.startScreenCapture();
      // return if stream cancelled
      if (stream === SeminarMode.errors.cancelled) {
        return stream;
      }
    }
    return stream;
  }
  // Start screen recording
  async onStartScreenRecording() {
    if(document.querySelector('#janus-extension-installed') !== null) {
      document.title = SeminarMode.essentials.recordTabTitle;
      window.postMessage("getRecordStream");
      window.addEventListener(
        "message",
        onRecordRelatedMessage.bind(this),
        false
      );
    } else {
      this.setState({ listModalOpen: true, listModalPurpose: "plugin" });
    }
  }

  // save blob to indexedDB
  saveBlob = (key) => {
    const blob = new Blob(this.chunks, {type: 'video/webm'});
    putBlobInDb(blob, key, this.roomName);
  }

  // Stop media recording
  onStopScreenRecording = () => {
    this.setState({
      listModalOpen: true,
      listModalPurpose: 'endRecording',
      isRecording: false,
      recordingKey: null
    });
    if (document.title === SeminarMode.essentials.recordTabTitle) {
      document.title = this.state.tabTitle;
    }
  }

  stopCapturing = (e) => {
    this.stream.getTracks().forEach(track => track.stop())
    this.stream = null;
  }

  stopRecordingStream = () => {
    this.recordingStream.getTracks().forEach(track => track.stop())
    this.recordingStream = null;
  }

  // **********P2P Logic Start**********
  _createPC = (socketId, isOffer, stream, screen, originId) => {
    const pc = new RTCPeerConnection({iceServers: iceServers, iceCandidatePoolSize: 6, sdpSemantics: "unified-plan"});
    if(screen){
      if(originId == this.socket.id ){  
        this.pcScreenMyPeers[socketId] = pc;
      }else{
        this.pcScreenPeers[socketId] = pc;
      }
    }else{
      this.pcPeers[socketId] = pc;
    }
    pc.onicecandidate = (e) => {
      webrtcLog(socketId, "pc.onnegotiationneeded", e)
      if (e.candidate) {
        webrtcLog(socketId, "event.candidate", this.editTable.candidate)
        this.socket.emit( screen ? 'screen_exchange' : 'exchange',  {'to': socketId, 'candidate': e.candidate, 'bitrate_index': this.state.bitrate_index, originId: originId, mobile: false });
      }
    };
    pc.onnegotiationneeded = async (e) => {
      webrtcLog(socketId, "pc.onnegotiationneeded", e)
      if (isOffer) {
        const offerOptions = { // スクリーンシェアの場合必要ない??
          offerToReceiveAudio: true,
          offerToReceiveVideo: true
        };
        try{
          const offer = await pc.createOffer(offerOptions)
          if (pc.signalingState != "stable"){
            webrtcLog(socketId, "skip sending the offer because pc.signalingState is not stable")
            return
          } 
          const temp = screen ? parseInt(bitrate_const[2].bitrate / 1000 ) : parseInt(bitrate_const[1].bitrate / 1000 / 2 )
          offer.sdp = sdpUtil.addVideoBandwidth(offer.sdp, temp);
          offer.sdp = sdpUtil.filterAudioCodec(offer.sdp, "opus");          
          offer.sdp = sdpUtil.filterVideoCodec(offer.sdp, "H264");
          await pc.setLocalDescription(offer)
          this.socket.emit( screen ? 'screen_exchange' : 'exchange', {'to': socketId, 'sdp': pc.localDescription, 'bitrate_index': this.state.bitrate_index, originId: originId, mobile: false})
        }catch(err){
          isSentry(err)
        }
      }
    }
    pc.oniceconnectionstatechange = (e) => {
      webrtcLog(socketId, "pc.oniceconnectionstatechange", e.target.iceConnectionState)
      if (e.target.iceConnectionState === 'completed') {
      }
      if (e.target.iceConnectionState === 'connected') {
        webrtcLog("this.changeBitrate")
        this.changeBitrate(screen ? "screen join" : 'video join')
      }
    };
    pc.onsignalingstatechange = (e) => {
      webrtcLog(socketId, "pc.onsignalingstatechange" , e, pc.signalingState)
    };
    pc.onaddstream =  (e) => {
      webrtcLog(socketId, "pc.onaddstream",e)
      this.setState({isCountStart: true})
      let remotestream = {key: UTIL.makeid(), id: screen ? socketId + "screen" : socketId, name: "display", stream: e.stream, group: 0, mute: false, screen: screen, you: false, hear: false, pc: true, audioTag: false};
      this.props.addRemoteVideoUser(remotestream)
    };
    pc.ontrack =  (e) => {
      webrtcLog(socketId, "pc.ontrack",e)
    };
    pc.onremovestream = (e) => {
      webrtcLog(socketId, "pc.onremovestream", e)
    };
    if( !(!isOffer && screen)){
      pc.addStream(stream);
    }
    return pc;
  }
  changeBitrate = async (eventName) => {
    for (const i in this.pcPeers) {
      try{ 
        const pc = this.pcPeers[i]
        console.log(pc.signalingState)
        if (pc.signalingState == "stable"){
          const sender = pc.getSenders()[1];
          const parameters = sender.getParameters();
          if (!parameters.encodings) {
            parameters.encodings = [{}];
          }
          const  bitrateTemp = parseInt(bitrate_const[this.pcBitrateIndex[i]].bitrate / (Object.keys(this.pcPeers).length + Object.keys(this.pcScreenPeers).length + Object.keys(this.pcScreenMyPeers).length + 1) )
          parameters.encodings[0].maxBitrate = bitrateTemp;
          await sender.setParameters(parameters)
        }
      }catch (err){
        isSentry(err)
      }
    }
  }
  prepareP2P = async () => { // P2P
    let deviceState
    let audioDeviceId = null
    let videoDeviceId = null

    try{
      if(!isWebinar()){
        this.setState({ 
          initialize: true, 
          listModalOpen: sessionStorage.getItem('copylink') ? false : true, 
          listModalPurpose: "copylink", 
          sessionCopyLink: sessionStorage.setItem('copylink',window.location.href),
        })
        setTimeout(function(){
          this.setState({initialize: true,listModalOpen: false});
        }.bind(this), 5000); 
      }else{
        this.setState({ initialize: true, listModalOpen: false})
      }
      let constrains = await checkStorageDevice( localStorage.getItem('audioDeviceId'), localStorage.getItem('videoDeviceId'))
      if (constrains.audio) {
        audioDeviceId = constrains.audio
      }
      if (constrains.video) {
        videoDeviceId = constrains.video
      }
      // TODO: check whether the requested device exits or not
      if(!isSafari()){
        this.localStream = await navigator.mediaDevices.getUserMedia({video: constrains.video ? ({ deviceId: videoDeviceId }) : true, audio: constrains.audio ? { deviceId: audioDeviceId } : true });
      }else{
        let videoConstraint = (localStorage.getItem('videoDeviceLabel') == "Back Camera") || (localStorage.getItem('videoDeviceLabel') == "背面側カメラ") ? "environment" : "user"
        this.localStream = await navigator.mediaDevices.getUserMedia({video: {facingMode: videoConstraint}, audio: constrains.audio ? { deviceId: audioDeviceId } : true });
      }
      // console.log("this.localStream.getAudioTracks()[0].getSettings()", this.localStream.getAudioTracks()[0].getSettings())
      // console.log("this.localStream.getVideoTracks()[0].getSettings()", this.localStream.getVideoTracks()[0].getSettings())
      await checkDevice(this.notificationSystem.current)
    }catch(err){
      this.setState({ initialize: true, listModalOpen: false})
      deviceState = await checkDevice(this.notificationSystem.current)
      if(deviceState.webcam == 1 && deviceState.mic == 1){
        this.localStream = await navigator.mediaDevices.getUserMedia({video: { deviceId: videoDeviceId }, audio: { deviceId: audioDeviceId } });
      }
      if(deviceState.webcam == 0 && deviceState.mic == 1){
        this.localStream = await navigator.mediaDevices.getUserMedia({video: false, audio: { deviceId: audioDeviceId } });
        this.setState({ disabledVideoPermission: true})
      }
      if(deviceState.webcam == 1 && deviceState.mic == 0){
        this.setState({ disabledAudioPermission: true})
        await this.notificationSystem.current.addNotification({
          message: 'Web会議を開始できませんでした',
          level: 'error',
          position: 'tc',
          autoDismiss: 60
        });
        let deviceInfos = await navigator.mediaDevices.enumerateDevices()
        this.initDevices(deviceInfos)
        // this.localStream = await navigator.mediaDevices.getUserMedia({video: true, audio: false});
      }
      if(deviceState.webcam == 0 && deviceState.mic == 0){
        this.setState({ disabledAudioPermission: true , disabledVideoPermission: true})
        await this.notificationSystem.current.addNotification({
          message: 'Web会議を開始できませんでした',
          level: 'error',
          position: 'tc',
          autoDismiss: 60
        });
        let deviceInfos = await navigator.mediaDevices.enumerateDevices()
        this.initDevices(deviceInfos)
        // this.localStream = await navigator.mediaDevices.getUserMedia({video: false, audio: false});
      }
      isSentry(err)
    }
    if(config.SOCKET_IO_DEBUG){
      webrtcLog("SOCKET_IO_DEBUG", config.SOCKET_IO_DEBUG)
    }
    const host = config.SOCKET_IO_DEBUG ? "localhost:4500/" : `https://${config.API_HOST}/`
    this.socket = io.connect(host, {
      path: '/sessions/socket.io',
      transports: ['websocket']
    });
    const join = (roomID) =>  {
      this.socket.emit('join2', {roomID: roomID, bitrate_index: this.state.bitrate_index}, (socketIds) => {
      });
    }
    const exchange = async (data, screen) => {
      this.pcBitrateIndex[data.from] = data.bitrate_index;
      const fromId = data.from;
      let pc;
      if(screen){
        if(data.originId == this.socket.id ){
          if (fromId in this.pcScreenMyPeers) { // mobile works
            pc = this.pcScreenMyPeers[fromId];
          } else {
            pc = this._createPC(fromId, false, this.localStream, screen, data.originId);
          }
        }else{
          if (fromId in this.pcScreenPeers) { // pc works
            pc = this.pcScreenPeers[fromId];
          } else {
            pc = this._createPC(fromId, false, this.localStream, screen, data.originId);
          }
        }
      }else{
        if (fromId in this.pcPeers) {
          pc = this.pcPeers[fromId];
        } else {
          if (data.sdp) {
            pc = this._createPC(fromId, false, this.localStream, screen, data.originId);
          }
        }
      }
      if (data.sdp) {
        try{
          await pc.setRemoteDescription(new RTCSessionDescription(data.sdp))
          if(pc.remoteDescription.type == "offer"){
            const ans = await pc.createAnswer()
            const temp = screen ? parseInt(bitrate_const[2].bitrate / 1000 ) : parseInt(bitrate_const[1].bitrate / 1000 / 2 )
            ans.sdp = sdpUtil.addVideoBandwidth(ans.sdp, temp);
            ans.sdp = sdpUtil.filterAudioCodec(ans.sdp, "opus");
            ans.sdp = sdpUtil.filterVideoCodec(ans.sdp, "H264");
            await pc.setLocalDescription(ans)
            this.socket.emit(screen ? 'screen_exchange' : 'exchange', {'to': fromId, 'sdp': pc.localDescription, 'bitrate_index': this.state.bitrate_index, originId: data.originId, mobile: false});
          }
        }catch(err){
          isSentry(err)
        }
      } else {
        pc.addIceCandidate(new RTCIceCandidate(data.candidate));
      }
    }
    const leave = (socketId, screen, left) => {
      if(socketId != this.socket.id){
        if(screen){
          const pc = this.pcScreenPeers[socketId];
          if(pc){
            pc.close();
            delete this.pcScreenPeers[socketId];
          }
        }else{
          const pc = this.pcPeers[socketId];
          if(pc){
            pc.close();
            delete this.pcPeers[socketId];
          }
        }
      } 
      if(left){
        const pc = this.pcScreenMyPeers[socketId]
        if(pc){
          pc.close()
          delete this.pcScreenMyPeers[socketId];
        }
      }
      if(left){
        this.changeBitrate("left event")
      }else if(!left && screen ){
        this.changeBitrate("end screen event")
      }
    }
    this.socket.on('chat', (data) => {
      queue.add(() => new Promise((resolve) => { // TODO: refactor
        var chat = this.state.chat
        var type = 'image/png;base64';
        var data_temp = window.atob(data.base64Data);
        var buff = new ArrayBuffer(data_temp.length);
        var arr = new Uint8Array(buff);
        var blob, i, dataLen;
        for (i = 0, dataLen = data_temp.length; i < dataLen; i++) {
          arr[i] = data_temp.charCodeAt(i);
        }
        blob = new Blob([arr], { type: type });
        data.blob = URL.createObjectURL(blob);
        chat[0].push(data)
        this.setState({ notify_count:  this.state.notify_count + 1})
        this.setState({ chat: chat })
        return resolve()
      }))
    });
    this.socket.on('exchange', (data) => {
      exchange(data, false);
    });
    this.socket.on('join_event', (data) => {
      this.pcBitrateIndex[data.socket_id] = data.data.bitrate_index;
      if(this.socket.id != data.socket_id){
        if(this.state.screen_publish_state){
          this._createPC(data.socket_id, true, this.streamScreen, true, this.socket.id);
        }
        this._createPC(data.socket_id, true, this.localStream, false, this.socket.id);
      }
      let remotestream = {key: UTIL.makeid() ,id: 0 ,name: "your_view", stream: this.localStream, full: false, group: 0, mute: true, screen: false, you: true, hear: false, pc: true, audioTag: false};
      if(this.localStream)
        this.props.addRemoteVideoUser(remotestream)
    });
    this.socket.on('screen_exchange', (data) => {
      exchange(data, true);
    });
    this.socket.on('bitrate_index_change', (data) => {
      // console.log(data, "bitrate_index_change")
      if(this.socket.id != data.socket_id){
        // console .log("bitrate_index_change", data.socket_id, data.bitrate_index)
        this.pcBitrateIndex[data.socket_id] = data.bitrate_index;
        this.changeBitrate("bitrate_index_change event")        
      }
    });
    this.socket.on('screen_end2', (data) => {
      // console.log("screen_end2 event")
      leave(data.socketId, true, false);
      this.props.deleteRemoteVideoUser(data.originId + "screen")
    });
    this.socket.on('leave', (socketId) => {
      // console.log("leave event")
      delete this.pcBitrateIndex[socketId];
      leave(socketId, false, true);
      this.props.deleteRemoteVideoUser(socketId)
      this.props.deleteRemoteVideoUser(socketId + "screen")
    });
    this.socket.on('connect', async (data) => {
      let deviceInfos = await navigator.mediaDevices.enumerateDevices()
      this.initDevices(deviceInfos)
      this.saveDatabaseMember()
    });
    join(this.roomName);
  };
  // **********P2P Logic End**********
  isChromeCompatible = () => {
    const chromeVersion = getChromeVersion();
    if (chromeVersion >= 72) {
      return true;
    }
    return false;
  }

  checkDisplayMediaCompatibility = (stream) => {
    if (
      this.isChromeCompatible()
      && stream !== null
      && stream !== undefined
      && stream !== false
      && !isWebinar()
    ) {
      return true;
    }
    return false;
  }

  onStartScreenShare = async (name, room) => {
    if(!isWebinar()){ // P2P 
      this.streamScreen = await this.getScreenStream();
      if (this.streamScreen === SeminarMode.errors.cancelled) return;
      this.streamScreen.addEventListener('inactive', e => {
        console.log('Capture stream inactive - stop recording!');
        // stop capturing
        if (this.streamScreen) {
          this.streamScreen.getTracks().forEach(track => track.stop())
          this.streamScreen = null;
          this.onStopScreenShare();
        }
      });
      if (this.ss) {
        this.streamScreen.getVideoTracks()[0].onended = () => {
          this.onStopScreenShare()
        }
      }
      
      let remotestream = {
        key: UTIL.makeid(),
        id: 1,
        name: "your_view" + ":" + "screen",
        stream: this.streamScreen,
        full: false,
        group: 0,
        mute: true,
        screen: true,
        you: true,
        hear: false,
        pc: true
      };

      this.props.addRemoteVideoUser(remotestream)
      this.setState({ screen_publish_state: true })
      const join = (roomID) =>  {
        this.socket.emit('screen_start', roomID, (socketIds) => {
          for (const i in socketIds) {
            const socketId = socketIds[i];
            if(this.socket.id != socketId){
              this._createPC(socketId, true, this.streamScreen, true, this.socket.id);
            }
          }
        });
      }
      join(this.roomName)
    } else {
      if(!Janus.isExtensionEnabled()) {
        this.setState({ listModalOpen: true, listModalPurpose: "plugin" });
        return;
      };
      var bitrate = bitrate_const[this.state.bitrate_index].bitrate
      var publish = { "request": "configure", "audio": false, "video": true, bitrate: bitrate, videocodec: this.state.codec  };
      database.ref(`/${config.FIREBASE_BASE}/${this.state.conference_id}/member/${this.state.user_uid}`)
        .update({audio: true, video: true})
      if (!this.state.screen_publish_state_init) {
        var register = { "request": "join", "room":  parseInt(room), "ptype": "publisher", "display":  "pc:" + this.state.name + ":" + "screen_on" + ":" + this.state.group};
        sfutest1.send({"message": register});
        sfutest1.muteAudio();
        this.setState({ screen_publish_state: true, screen_publish_state_init: true })
      }else{
        sfutest1.createOffer(
          {
            media: { video: "screen", audio: true, videoRecv: false},
            success: (jsep) => {
              sfutest1.send({"message": publish, "jsep": jsep});
              sfutest1.muteAudio();
            },
            error: (error) => {
            }
          });
        this.setState({ screen_publish_state: true })
      }
    }
  }

  onStopScreenShare = () => {
    try{ 
      if(!isWebinar()){ // P2P
        if (this.stream) {
          this.stopCapturing();
        }
        if (this.streamScreen) {
          this.streamScreen.getTracks().forEach(track => track.stop())
          this.streamScreen = null;
        }
        if (this.ss) {
          this.ss.stop();
          this.ss = null;
        }
        this.setState({ screen_publish_state: false})
        this.props.deleteRemoteVideoUser(1)
        for (const i in this.pcScreenMyPeers) {
          try{
            const pc = this.pcScreenMyPeers[i]
            pc.close()
            delete this.pcScreenMyPeers[i];
          }catch(err){
            isSentry(err)
          }
        } 
        this.socket.emit('screen_end2', {roomName: this.roomName, originId: this.socket.id})
      }else{
        var unpublish = { "request": "unpublish" };
        sfutest1.send({"message": unpublish});
        sfutest1.muteAudio();
        this.setState({ screen_publish_state: false})
        this.props.deleteRemoteVideoUser(this.state.screen_my_feed_id)
      }
    }
    catch(error){
      const message = "screen share onStopScreenShare() failed"
      isSentryBreadcrumbs(error,message)
    }  
  }
  handleTouchTap = (e, message) => {
    this.setState({
      snackbarOpen: true,
      snackbarMessage: message
    });
  };
  handleRequestClose = () => this.setState({ snackbarOpen: false });
  handleListModalClose = () => this.setState({ listModalOpen: false });
  handleListClick = (e, purpose, arg1, arg2, arg3) => {
    try{
      if (purpose === 'record') {
        this.toggleRecord();
      } else if (purpose == "video") {
        this.toggleVideoMute()
      }else if(purpose == "mic"){
        this.toggleMute()
      }else if(purpose == "accept"){
        if (this.state.role == "teacher") {
          if (arg1) {
            database.ref(`/${config.FIREBASE_BASE}/${this.state.conference_id}/raise`).child(arg2).update({raise: true})
          }else{
            database.ref(`/${config.FIREBASE_BASE}/${this.state.conference_id}/raise`).child(arg2).remove()
          }
        }
      }else if(purpose == "raise"){
        if (this.state.raise && !this.state.raise_disable) {
          this.setState({ raise: false });
          database.ref(`/${config.FIREBASE_BASE}/${this.state.conference_id}/raise`).child(this.state.user_uid).remove()
        }else if( !this.state.raise && !this.state.raise_disable){
          this.setState({ raise: true });
          database.ref(`/${config.FIREBASE_BASE}/${this.state.conference_id}/raise`).child(this.state.user_uid)
            .update({raise: false, uid: this.state.user_uid, name: this.state.name, user_id: this.state.user_id, direct: this.state.direct})
        }else if(this.state.raise_disable){
          database.ref(`/${config.FIREBASE_BASE}/${this.state.conference_id}/raise`).child(this.state.user_uid).remove()
        }
      }else if(purpose == "share"){
        if (this.state.screen_publish_state) {
          this.onStopScreenShare()
        }else{
          this.onStartScreenShare(this.state.name,this.state.room)
        }
      }else if(purpose == "settings"){
        this.setState({ listModalOpen: true, listModalPurpose: purpose });
      }else if(purpose == "end"){
        this.setState({ listModalOpen: true, listModalPurpose: purpose });
      }else if(purpose == "breakout"){
        this.setState({ listModalOpen: true, listModalPurpose: purpose });
      }
    }
    catch(error){
      const message = "controls handleListClick() failed"
      isSentryBreadcrumbs(error,message)
    }
  }

  returnConstraintsP2P = (audio_device_value_index, video_device_value_index, audio_output_device_value_index) => {
    if (audio_device_value_index != 0) {this.setState({ audio_device_value_index })}
    if (audio_output_device_value_index != 0) {this.setState({ audio_output_device_value_index })}
    if (video_device_value_index != 0) {this.setState({ video_device_value_index: video_device_value_index})}
    var audioSource = this.state.audio_device[audio_device_value_index].deviceId
    var audioOutputSource = this.state.audio_output_array[audio_output_device_value_index].deviceId
    var videoSource = this.state.video_device[video_device_value_index].deviceId
    const constraints = {
      audio: {deviceId: audioSource ? {exact: audioSource} : undefined},
      video: {deviceId: videoSource ? {exact: videoSource} : undefined},
    };
    return constraints

  }
  handleDeviceSave = async (audio_device_value_index, video_device_value_index, bitrate_index, audio_output_device_value_index) => {
    try{
    if(!isWebinar()){ // P2P

      // bitrate_index low:3, middle:2, high:1
      this.socket.emit('bitrate_index_change', {roomName: this.roomName, bitrate_index: bitrate_index})
      this.setState({ bitrate_index: bitrate_index})
  

      let audioDeviceId, videoDeviceId
      let constrains = await checkStorageDevice( localStorage.getItem('audioDeviceId'), localStorage.getItem('videoDeviceId'))
      if (constrains.audio) {
        audioDeviceId = constrains.audio
      }
      if (constrains.video) {
        videoDeviceId = constrains.video
      }
      if(!isSafari()){
        this.localStream = await navigator.mediaDevices.getUserMedia({video: constrains.video ? ({ deviceId: videoDeviceId }) : true, audio: constrains.audio ? { deviceId: audioDeviceId } : true });      
      }else{
        let videoConstraint = localStorage.getItem('videoDeviceLabel') == "Back Camera" ? "environment" : "user"
        this.localStream = await navigator.mediaDevices.getUserMedia({video: {facingMode: videoConstraint}, audio: constrains.audio ? { deviceId: audioDeviceId } : true });
      }
      this.props.updateStream( {id: 0, stream: this.localStream })
    
      for (const i in this.pcPeers) {
        let videoTrack = this.localStream.getVideoTracks()[0];
        const pc = this.pcPeers[i]
        let sender = pc.getSenders().find((s) =>{
          return s.track.kind == videoTrack.kind;
        });
        try{
          await sender.replaceTrack(videoTrack);
        }catch(err){
          isSentry(err)
        }
      }

      for (const i in this.pcPeers) {
        let audioTrack = this.localStream.getAudioTracks()[0];
        const pc = this.pcPeers[i]
        let sender = pc.getSenders().find((s) =>{
          return s.track.kind == audioTrack.kind;
        });
        try{
          await sender.replaceTrack(audioTrack);
        }catch(err){
          isSentry(err)
        }
      }


      if (audio_device_value_index != 0) {
        console.log("device change")
        this.setState({ audio_device_value_index: audio_device_value_index})
      }

      if (video_device_value_index != 0) {
        console.log("bitrate change")
        this.setState({ video_device_value_index: video_device_value_index})
      }
      this.setState({ listModalOpen: false})
    }else{
      if (audio_device_value_index != 0) {this.setState({ audio_device_value_index: audio_device_value_index})}
      if (audio_output_device_value_index != 0) {this.setState({ audio_output_device_value_index })}
      if (video_device_value_index != 0) {this.setState({ video_device_value_index: video_device_value_index})}
      if (bitrate_index) {this.setState({ bitrate_index: bitrate_index})}
      this.onStopPublish()
      setTimeout(()=>{this.publishOwnFeed()}, 2000)
    }
   }
   catch(error){
    const message = "Devices handleDeviceSave() failed"
    isSentryBreadcrumbs(error,message)
   }
  }
  handleAudioDeviceChange(event) {
    try{
      event.preventDefault();
      for (var i = this.state.audio_device.length - 1; i >= 0; i--) {
        if(this.state.audio_device[i]["label"] == event.target.value){
          this.setState1({audio_device_value: event.target.value, audio_device_value_id: this.state.audio_device[i]["deviceId"], set_device_audio: true});
        }
      }
    }  
    catch(error){
      const message = "Audio devices handleAudioDeviceChange() failed"
      isSentryBreadcrumbs(error,message)
    }  
  }
  handleVideoDeviceChange(event) {
    try{
      event.preventDefault();
      for (var i = this.state.video_device.length - 1; i >= 0; i--) {
        if(this.state.video_device[i]["label"] == event.target.value){
          this.setState({video_device_value: event.target.value, video_device_value_id: this.state.video_device[i]["deviceId"], set_device_video: true});
        }
      }
    }  
    catch(error){
      const message = "Video devices handleVideoDeviceChange() failed"
      isSentryBreadcrumbs(error,message)
    }   
  }
  onChangeDevice=(e)=>{
    e.preventDefault()
    if (!this.state.set_device_audio && this.state.set_device_video || this.state.set_device_audio && !this.state.set_device_video) {
      alert("Set both device!!")
      return
    }
    this.onStopPublish()
    setTimeout(()=>{this.publishOwnFeed()}, 2500)
  }

  getDeviceList= async () => {
    try{
      if(!isWebinar()){ // P2P
        let deviceInfos = await navigator.mediaDevices.enumerateDevices({ audio: true, video: true })
        console.log(deviceInfos)
        this.initDevices(deviceInfos)
      }else{
        Janus.listDevices(this.initDevices);
      }
    }  
    catch(error){
      const message = "Devices getDeviceList() failed"
      isSentryBreadcrumbs(error,message)
    }  
  }
  initDevices = (devices) => {
    if(!isWebinar()){ // P2P
      let audio_array = [{deviceId: null, label: "マイクの選択"}]
      const audio_output_array = [{deviceId: null, label: "スピーカーの選択"}]
      let video_array = [{deviceId: null, label: "Webカメラの選択"}]
      var video_send = false
      devices.forEach((device) => {
        var label = device.label;
        if(label === null || label === undefined || label === "")
          label = device.deviceId;
        if(device.kind === 'audioinput') {
          audio_array.push({deviceId: device.deviceId, label: label})
        } else if(device.kind === 'videoinput') {
          video_array.push({deviceId: device.deviceId, label: label})
          video_send = true
        } else if (device.kind === 'audiooutput') {
          audio_output_array.push({deviceId: device.deviceId, label: label})
        }
      });
      this.setState({ audio_device:  audio_array,  video_device: video_array, video_send: video_send, audio_output_array })
    }else{
      let audio_array = [{deviceId: null, label: "マイクの選択"}]
      const audio_output_array = [{deviceId: null, label: "マイクの選択"}]
      let video_array = [{deviceId: null, label: "Webカメラの選択"}]
      var video_send = false
      devices.forEach(function(device) {
        var label = device.label;
        if(label === null || label === undefined || label === "")
          label = device.deviceId;
        if(device.kind === 'audioinput') {
          audio_array.push({deviceId: device.deviceId, label: label})
        } else if(device.kind === 'videoinput') {
          video_array.push({deviceId: device.deviceId, label: label})
          video_send = true
        } else if (device.kind === 'audiooutput') {
          audio_output_array.push({deviceId: device.deviceId, label: label})
        }
      });
      if(!video_send){
        this.onStopPublish()
        // alert("no video device found!!")
      }else{
        this.setState({ audio_device:  audio_array,  video_device: video_array, video_send: video_send, audio_output_array })
      }
    }
  }
  janusStart = () => {
    Janus.init({debug: "null", callback: () => {
      janus = new Janus(
                {   server: "wss://" + config.API_HOST +"/janus",
                    iceServers: iceServers,
                    iceTransportPolicy: config.API_HOST == "workshop.tokyo" ? "relay" : "all",
                    success: () => {
                      janus.attach({ // screen share
                        plugin: "janus.plugin.videoroom",
                        success: (pluginHandle) =>{
                            sfutest1 = pluginHandle;
                        },
                        onlocalstream: (stream) => {
                          stream.getVideoTracks()[0].onended = () => {
                            this.onStopScreenShare()
                          }
                          var remotestream = {key: UTIL.makeid() ,id: this.state.screen_my_feed_id , name:  this.state.name + ":" + "screen", stream: stream, full: false, group: this.state.group, mute: true, screen: true, you: true, hear: false, pc: true};
                          this.props.addRemoteVideoUser(remotestream)
                        },
                        webrtcState: (on) => {
                        },
                        error: (error) => {
                        },
                        onmessage: (msg, jsep) => {
                            var event = msg["videoroom"];
                            if(event != undefined && event != null) {
                              if(event === "joined") {
                                sfutest1.createOffer(
                                  {
                                    media: { video: "screen", audio: true, videoRecv: false},
                                    success: function(jsep) {
                                      var publish = { "request": "configure", "audio": true, "video": true };
                                      sfutest1.send({"message": publish, "jsep": jsep});
                                      sfutest1.muteAudio();
                                    },
                                    error: function(error) {
                                      Janus.error("WebRTC error:", error);
                                    }
                                  });
                                if(isWebinar()){
                                  // TODO: レコードがON時だけ叩く
                                  setRecord(this.state.name + ":screen", this.state.room, msg["id"]).then(x => {})
                                }
                                this.setState({ screen_my_feed_id: msg["id"]})
                              }
                            }
                            if(jsep !== undefined && jsep !== null) {
                                sfutest1.handleRemoteJsep({jsep: jsep});
                            }
                        }
                      });
                      janus.attach(
                            {
                                plugin: "janus.plugin.videoroom",
                                success: (pluginHandle) => {
                                    sfutest = pluginHandle;
                                    var register = { "request": "join", "room": parseInt(this.state.room), "ptype": "publisher", "display": "pc:"+this.state.name + ":" + "screen_off" + ":" + this.state.group };
                                    sfutest.send({"message": register});
                                },
                                onmessage: (msg, jsep) => {
                                    var event = msg["videoroom"];
                                    if(event != undefined && event != null) {
                                        if(event === "joined") {
                                            var video_send = false
                                            this.setState({ my_feed_id: msg["id"]})
                                            if(isWebinar()){
                                              // TODO: レコードがON時だけ叩く
                                              setRecord(this.state.name, this.state.room,msg["id"]).then(x => {})
                                            }
                                            setTimeout(()=>{this.publishOwnFeed()}, 1000)
                                            if(msg["publishers"] !== undefined && msg["publishers"] !== null) {
                                                var list = msg["publishers"];
                                                if (!this.state.blockFeed) {
                                                  this.triggerNewRemoteFeed(list)
                                                }
                                            }
                                        } else if(event === "event") {
                                            if(msg["publishers"] !== undefined && msg["publishers"] !== null) {
                                                if(msg["publishers"] !== undefined && msg["publishers"] !== null) {
                                                  var list = msg["publishers"];
                                                  if (!this.state.blockFeed) {
                                                    this.triggerNewRemoteFeed(list)
                                                  }
                                                }
                                            } else if(msg["leaving"] !== undefined && msg["leaving"] !== null) {
                                                this.props.deleteRemoteVideoUser(msg["leaving"])
                                            } else if(msg["unpublished"] !== undefined && msg["unpublished"] !== null) {
                                              if (msg["unpublished"] != "ok") {
                                                this.props.deleteRemoteVideoUser(msg["unpublished"])
                                              }
                                            } else if(msg["error"] !== undefined && msg["error"] !== null) {
                                              var res = msg["error"].match(/No such room/g);
                                              if(res){
                                                alert("No such seminar. You should recreate the seminar again. Please report this error to the system admin.")
                                              }
                                            }
                                        }
                                    }
                                    if(jsep !== undefined && jsep !== null) {
                                      sfutest.handleRemoteJsep({jsep: jsep});
                                    }
                                },
                                onlocalstream: (stream) => {
                                    if(!isWebinar()){ // P2P
                                      var remotestream = {key: UTIL.makeid() ,id: this.state.my_feed_id ,name: "your_view", stream: stream, full: false, group: this.state.group, mute: true, screen: false, you: true, hear: false, pc: true};
                                      this.props.addRemoteVideoUser(remotestream)
                                    }else{
                                      var remotestream = {key: UTIL.makeid() ,id: this.state.my_feed_id ,name: "your_view", stream: stream, full: false, group: this.state.group, mute: true, screen: false, you: true, hear: false, pc: true};
                                      this.props.addRemoteVideoUser(remotestream)
                                      speechEvents = hark(stream, {});
                                      speechEvents.on('speaking', () => {
                                        database.ref(`/${config.FIREBASE_BASE}/${this.state.conference_id}/group`).child(this.state.user_uid).update({speak: true, uid: this.state.user_uid, group: this.state.group, name: this.state.name, role: this.state.role})
                                      });
                                      speechEvents.on('stopped_speaking', () => {
                                        database.ref(`/${config.FIREBASE_BASE}/${this.state.conference_id}/group`).child(this.state.user_uid).update({speak: false, uid: this.state.user_uid, group: this.state.group, name: this.state.name, role: this.state.role})
                                      });
                                    }
                                  },
                                });
                                },
                                destroyed: () => {
                                  try{
                                    speechEvents.stop()
                                  }catch(err){
                                    isSentry(err)
                                  }
                                }
                       });
        }});
  }
  triggerNewRemoteFeed = (list) => {
    var my_screen_if = this.state.name + ":screen_on:" + this.state.group
    for(var f in list) {
      let id = list[f]["id"]
      let display = list[f]["display"]
      let display_split = list[f]["display"].split(":")
      if (this.state.mode == "breakout") {
        if ( display_split[3] == this.state.group || !this.state.break_join ) { // bug fix
          if (display != my_screen_if ) {
            queue.add(() => new Promise((resolve) => {
              this.newRemoteFeed(id, display_split[0], display_split[1], display_split[2], display_split[3], resolve)
            }));
          }
        }
      }else if(this.state.mode == "seminar" || !isWebinar() ){
        if (display != my_screen_if ) {
          queue.add(() => new Promise((resolve) => {
            this.newRemoteFeed(id, display_split[0], display_split[1], display_split[2], display_split[3], resolve)
          }));
        }
      }
    }
  }
  newRemoteFeed = (id, device_type, display, screen_flag, group, resolve ) => {
    var remoteFeed = null;
    janus.attach(
      {
        plugin: "janus.plugin.videoroom",
        success: (pluginHandle) => {
          remoteFeed = pluginHandle;
          var listen = { "request": "join", "room": parseInt(this.state.room), "ptype": "listener", "feed": id };
          remoteFeed.send({"message": listen});
        },
        onmessage: (msg, jsep) => {
          var event = msg["videoroom"];
          if(event != undefined && event != null) {
            if(event === "attached") {}
          }
          if(jsep !== undefined && jsep !== null) {
            if (this.state.mode == "breakout" && this.state.role != "student" && !this.state.break_join ) {
              var media = { audioRecv: true, videoRecv: true, audioSend: false, videoSend: false}
            }else if(this.state.mode == "breakout" && this.state.role != "student" && this.state.break_join && this.state.group == 10 ){
              var media = { audioRecv: true, videoRecv: true, audioSend: false, videoSend: false}
            }else{
              var media = { audioRecv: true, videoRecv: true, audioSend: false, videoSend: false}
            }
            remoteFeed.createAnswer(
              {
                jsep: jsep,
                media: media,
                success: (jsep) => {
                  var body = { "request": "start", "room": parseInt(this.state.room) };
                  remoteFeed.send({"message": body, "jsep": jsep});
                },
                error: (error) => {
                }
            });
          }
        },
        onremotestream: (stream) => {
          var hear = ( typeof this.state.hear[group] != "undefined" ) ? (this.state.hear[group]) : (false)
          var screen = false
          if (screen_flag == "screen_on") {
            screen = true
            display = display + ":screen"
          }
          var remotestream = {key: UTIL.makeid(), id: id , name: display, stream: stream, pluginHandle:remoteFeed, group: group, mute: false, screen: screen, you: false, hear: hear, pc: device_type == "pc" ? true : false};
          this.props.addRemoteVideoUser(remotestream)
          return resolve()
        },
    });
  }
  toggleMute = async () => {
    try{
    if(!isWebinar()){ // P2P
      var audioTrack = this.localStream.getAudioTracks()[0];
      if(this.state.muteAudio){
        audioTrack.enabled = true
        this.setState({ muteAudio: false})
        await this.memberRef.update({ audio: true })
      }else{
        audioTrack.enabled = false
        this.setState({ muteAudio: true})
        await this.memberRef.update({ audio: false })
      }
    }else{
      var muted = sfutest.isAudioMuted();
      if(muted){
        this.setState({ muteAudio: false})
        database.ref(`/${config.FIREBASE_BASE}/${this.state.conference_id}/member/${this.state.user_uid}`)
          .update({ audio: true })
        sfutest.unmuteAudio();
      }else{
        this.setState({ muteAudio: true})
        database.ref(`/${config.FIREBASE_BASE}/${this.state.conference_id}/member/${this.state.user_uid}`)
          .update({ audio: false })
        sfutest.muteAudio();
      }
    }
  }
  catch(error){
    const message = "Video mute toggleMute() failed"
    isSentryBreadcrumbs(error,message)
  }
  }
  toggleVideoMute = async () => {
    try{
    if(!isWebinar()){
      var videoTrack = this.localStream.getVideoTracks()[0];
      if(this.state.muteVideo){
        videoTrack.enabled = true
        this.setState({ muteVideo: false})
        await this.memberRef.update({ video: true })
      }else{
        videoTrack.enabled = false
        this.setState({ muteVideo: true})
        await this.memberRef.update({ video: false })
      }
    }else{
      var muted = sfutest.isVideoMuted();
      if(muted){
        this.setState({ muteVideo: false})
        database.ref(`/${config.FIREBASE_BASE}/${this.state.conference_id}/member/${this.state.user_uid}`)
        .update({video: true})
        sfutest.unmuteVideo();
      }else{
        this.setState({ muteVideo: true})
        database.ref(`/${config.FIREBASE_BASE}/${this.state.conference_id}/member/${this.state.user_uid}`)
        .update({video: false})
        sfutest.muteVideo();
      }
    }
    }
    catch(error){
      const message = "Video mute toggleVideoMute() failed"
      isSentryBreadcrumbs(error,message)
    }
  }

  toggleRecord = () => {
    try{
      const { isRecording } = this.state;
      if (isRecording) {
        window.postMessage({ type: "stopScreenRecording", desktopId: this.recordingDesktopId });
      } else {
        this.onStartScreenRecording();
      };
    }
    catch(error){
      const message = "Recording toggleRecord() failed"
      isSentryBreadcrumbs(error,message)
    }
  }
  async saveDatabaseMember() {
    const now = moment().unix()

    this.memberRef = firestore
      .collection(`${config.FIREBASE_BASE}-rooms`)
      .doc(this.roomName)
      .collection('members')
      .doc(this.socket.id)

    await this.memberRef.set({
      audio: !this.state.muteAudio,
      name: this.state.name,
      screen: false,
      video: !this.state.muteVideo,
      uid: this.state.user_uid,
      unix_time: now,
      socket_id: this.socket.id
    })

    this.subscrbeDatabaseMembers()
  }

  async subscrbeDatabaseMembers() {
    const ref = firestore
      .collection(`${config.FIREBASE_BASE}-rooms`)
      .doc(this.roomName)
      .collection('members')

    ref.get().then(snapshot => {
      let members = this.state.databaseMembers
      snapshot.docs.forEach(doc => {
        const data = doc.data()
        members[data.socket_id] = data
      })
        this.setState({ databaseMembers: members })
    })

    this.unsubscribeDatabaseMembers = ref.onSnapshot(snapshot => {
      let members = this.state.databaseMembers
       snapshot.docChanges().forEach(change => {
         if (change.type === 'added' || change.type === 'modified') {
           const data = change.doc.data()
           members[data.socket_id] = data
          }
        })
         this.setState({ databaseMembers: members })
     })
  }

  publishOwnFeed = async () => {
    if(!isWebinar()){ // P2P
    }else{
      var bitrate = bitrate_const[this.state.bitrate_index].bitrate
      var audioSend
      var videoSend
      if (this.state.mode == "breakout") {
        if (!this.state.break_join) {
          this.setState({publish_state_default: false});
          audioSend =false
          videoSend =false
          this.setState({ listModalOpen: false})
        }else if (this.state.role != "student" && this.state.break_join) {
          this.setState({publish_state_default: true});
          audioSend=true
          videoSend=true
        }else if(this.state.role == "student" && this.state.break_join ){
          this.setState({publish_state_default: true});
          audioSend=true
          videoSend=true
        }
      }else if(this.state.mode == "seminar"){
        if (this.state.role == "teacher") {
          this.setState({publish_state_default: true});
          audioSend=true
          videoSend=true
        }else if(this.state.role != "teacher" && !this.state.raise){
          this.setState({publish_state_default: false});
          audioSend=false
          videoSend=false
          return this.setState({ listModalOpen: false})
        }else if (this.state.role != "teacher" && this.state.raise) {
          this.setState({publish_state_default: true});
          audioSend=true
          videoSend=true
        }
      }
      if (this.state.mode == "seminar" && this.state.role != "teacher") {
        var publish = { "request": "configure", "audio": audioSend, "video": videoSend, bitrate: bitrate, videocodec: this.state.codec  };
        database.ref(`/${config.FIREBASE_BASE}/${this.state.conference_id}/member/${this.state.user_uid}`)
          .update({ audio: audioSend, video: videoSend})
      }else{
        var publish = { "request": "configure", "audio": audioSend, "video": videoSend, bitrate: bitrate, videocodec: this.state.codec };
        database.ref(`/${config.FIREBASE_BASE}/${this.state.conference_id}/member/${this.state.user_uid}`)
          .update({ audio: audioSend, video: videoSend})
      }

      var audio = null
      var video = null
      let constrains = await checkStorageDevice( localStorage.getItem('audioDeviceId'), localStorage.getItem('videoDeviceId'))
      if (constrains.audio) {
        var audio_conf =
        { deviceId: { exact: constrains.audio } }
        audio = "audio"
      }
      if (constrains.video) {
        var video_conf =
        { deviceId: { exact: constrains.video } }
        video = "video"
      }
      sfutest.createOffer({
        media: { audioRecv: false, videoRecv: false, audioSend: audioSend, videoSend: videoSend,  [audio]: audio_conf, [video]: video_conf,  },
        success: (jsep) => {
          sfutest.send({"message": publish, "jsep": jsep});
          Janus.listDevices(this.initDevices);
          this.setState({ listModalOpen: false})
        },
        error: (error) => {
          this.setState({ listModalOpen: false})
        }
      });
    }
  }
  onStopPublish = () => {
    var unpublish = { "request": "unpublish" };
    sfutest.send({"message": unpublish});
    this.props.deleteRemoteVideoUser(this.state.my_feed_id)
    this.setState({muteVideo: false, muteAudio: false})
    database.ref(`/${config.FIREBASE_BASE}/${this.state.conference_id}/member/${this.state.user_uid}`)
      .update({audio: false, video: false})
    var unpublish = { "request": "unpublish" };
    sfutest1.send({"message": unpublish});
    this.props.deleteRemoteVideoUser(this.state.screen_my_feed_id)
  }
  audioMuteToggle=(full_id,mute)=>{
    console.log(full_id);
    this.props.audioMuteToggle(full_id,mute)
  }
  switchFullScreen=(full_id)=>{
    this.props.fullScreen(full_id)
  }
  delay=(t)=> {
    return new Promise(function(resolve) {
      setTimeout(resolve, t)
    });
  }
  janus_restart_helper=(break_join)=>{
    this.setState({ blockFeed: true})
    queue.add(() => new Promise((resolve) => {
      this.delay(300).then(() => {
      try {
        this.onStopPublish();
      }catch(err) {
        isSentry(err)
      }
      try {
          this.onStopScreenShare();
      }catch(err) {
          isSentry(err)
      }
      return this.delay(300)
      }).then(() => {
        try {
          this.setState({ listModalOpen: true, listModalPurpose: "loading" })
          janus.destroy()
        }catch(err) {
          isSentry(err)
        }
        var time = 3000
        if (this.state.mode == "seminar") {
          time = 1000
        }
        return this.delay(time)
      }).then(() => {
        this.setState({ break_join: break_join, screen_publish_state_init: false ,screen_publish_state: false, mute: false, publish_state_default: false})
        this.props.clearRemoteVideoUser()
        this.setState({ blockFeed: false})
        this.janusStart()
        return resolve()
      })
    })).then(() => {
    });
  }
  onEnterRoom = async (anonymous) => { // P2P enter
    if(!isWebinar()){
      this.setState({ name: UTIL.makeid() })
      this.setState({ user_uid: await md5(this.state.name) })
    } else {
      const y = await checkRoomState(this.state.conference_id, this.state.user_id)
      this.setState({ email: y["email"], room: y["room_id"]})
      if (!anonymous) {
        this.setState({ name: y["name"]})
      }else{
        this.setState({ role: this.state.selectedOption})
      }
      if (y["result"] == "end") {
        alert("このURLのセミナーは終了しています")
        window.location = config.WEBINAR_ADMIN_URL
      }else if (y["result"] == "none") {
        alert("このURLにセミナーはありません")
        window.location = config.WEBINAR_ADMIN_URL
      }else if (this.state.name == "") {
        this.setState({ nameError: true})
        return
      }else if(this.state.name.match(/:/)){
        alert("無効な名前です。名前を変更してください。")
        return
      }

      try{
        this.setState({ user_uid: md5(this.state.name), loading: true })
        let leaveMember = database.ref(`/${config.FIREBASE_BASE}/${this.state.conference_id}/member`).child(this.state.user_uid)
        let leaveGroup = database.ref(`/${config.FIREBASE_BASE}/${this.state.conference_id}/group`).child(this.state.user_uid)
        let leaveRaise = database.ref(`/${config.FIREBASE_BASE}/${this.state.conference_id}/raise`).child(this.state.user_uid)
        leaveMember.remove()
        leaveGroup.remove()
        leaveRaise.remove()
        this.refLeaveMember = database.ref(`/${config.FIREBASE_BASE}/${this.state.conference_id}/member`).child(this.state.user_uid).onDisconnect()
        this.refLeaveGroup = database.ref(`/${config.FIREBASE_BASE}/${this.state.conference_id}/group`).child(this.state.user_uid).onDisconnect()
        this.refLeaveRaise = database.ref(`/${config.FIREBASE_BASE}/${this.state.conference_id}/raise`).child(this.state.user_uid).onDisconnect()
        let connectedRef = database.ref('.info/connected')
        connectedRef.on('value', snap => {
          if (snap.val() === true) {
            this.refLeaveMember.remove()
            this.refLeaveGroup.remove()
            this.refLeaveRaise.remove()
          }
        })
        const memberRef = database.ref(`/${config.FIREBASE_BASE}/${this.state.conference_id}/member`);
        const memberObj = (await memberRef.once('value')).val()
        if (memberObj) {
          var count_teacher = 0
          Object.keys(memberObj).map((key) => {
            if (memberObj[key].role == "teacher") {
              count_teacher = count_teacher + 1
              if ( isWebinar() && count_teacher > 12 && this.state.role == "teacher") {
                alert("プレゼンターの人数は最大で12です")
                window.location = config.WEBINAR_ADMIN_URL
              }
            }
          })
        }
        const now = moment().unix()
        this.setState({ unix_time: now, loading: true, listModalOpen: true, listModalPurpose: "loading" })
        await database.ref(`/${config.FIREBASE_BASE}/${this.state.conference_id}/member/${md5(this.state.name)}`).set({
          audio: false,
          name: this.state.name,
          role: this.state.role,
          screen: false,
          video: false,
          uid: md5(this.state.name),
          user_id: this.state.user_id,
          unix_time: now,
          direct: this.state.direct
        })
        memberRef.on('child_added', (data) => {
          if(!isWebinar()){
            joinAudio.play()
          }
          this.props.addRemoteUser(data.val())
          this.setState({ count_participants: this.state.count_participants + 1 })
        })
        memberRef.on('child_changed', (data) => {
          if(( data.val().uid == this.state.user_uid ) && (data.val().unix_time != this.state.unix_time)){
            this.refLeaveMember.cancel()
            this.refLeaveGroup.cancel()
            this.refLeaveRaise.cancel()
            alert("他のユーザが同じ名前を使用しました")
            window.location = config.WEBINAR_ADMIN_URL
          }
          database.ref(`/${config.FIREBASE_BASE}/${this.state.conference_id}/member`).on("value", (snapshot) => {
            this.setState({databaseMembers: snapshot.val()})
          })
        })
        memberRef.on('child_removed', (data) => {
          this.props.deleteRemoteUser(data.val())
          this.setState({ count_participants: this.state.count_participants - 1 })
        })
        const modeRef = database.ref(`/${config.FIREBASE_BASE}/${this.state.conference_id}/mode`)
        const modeObj = (await modeRef.once('value')).val()
        if (modeObj) {
          this.setState({mode: modeObj.index})
          if (modeObj.index == "seminar") {
          }else if (modeObj.index == "breakout") {
            this.setState({break_join: false})
          }
        }else{
          database.ref(`/${config.FIREBASE_BASE}/${this.state.conference_id}/mode`).update({index: "seminar"});
          this.setState({mode: "seminar"})
        }
        modeRef.on('child_changed', (data) => {
          // TODO: "バグがある模様"
          this.setState({mode: data.val()})
          if (data.val() == "seminar") {
            this.janus_restart_helper(false)
          }else if (data.val() == "breakout") {
            var array = (this.props.main.groupList) ? ( this.props.main.groupList.filter(
              user => user["uid"] === this.state.user_uid ) ) : (null)
            var break_join = false
            if (array.length != 0 ) {
              if (array[0].group != 0 ) {
                break_join = true
                this.setState({ group: array[0].group })
              }
            }
            this.setState({break_join: break_join})
            this.janus_restart_helper(break_join)
          }else if (data.val() == "end") {
            alert("セミナーが終了しました。")
            window.location = config.WEBINAR_ADMIN_URL
          }
        })
        const restartRef = database.ref(`/${config.FIREBASE_BASE}/${this.state.conference_id}/restart`)
        restartRef.on('child_changed', (data) => {
          this.janus_restart_helper(false)
        })
        const tableRef = database.ref(`/${config.FIREBASE_BASE}/${this.state.conference_id}/table`)
        tableRef.on('child_added', (data) => {
          this.props.addTableUser(data.val())
        })
        tableRef.on('child_changed', (data) => {
          this.props.updateTableUser(data.val())
        })
        tableRef.on('child_removed', (data) => {
          this.props.deleteTableUser(data.val())
          if (data.val().group == this.state.group) {
            database.ref(`/${config.FIREBASE_BASE}/${this.state.conference_id}/group/${this.state.user_uid}`).update({ uid: this.state.user_uid, name: this.state.name, group: 0, speak: false, role: this.state.role })
          }
        })
        const raiseRef = database.ref(`/${config.FIREBASE_BASE}/${this.state.conference_id}/raise`);
        raiseRef.on('child_added', (data) => {
          this.props.addRaiseUser(data.val())
          this.setState({ notify_count:  this.state.notify_count + 1})
          audio.play()
        })
        raiseRef.on('child_changed', (data) => {
          this.props.updateRaiseUser(data.val())
          if (data.val().uid == this.state.user_uid && data.val().raise) {
            this.setState({raise: true});
            this.setState({raise_disable: true});
            this.setState({ listModalOpen: true, listModalPurpose: "loading" })
            this.publishOwnFeed()
          }
        })
        raiseRef.on('child_removed', (data) => {
          this.props.deleteRaiseUser(data.val())
          if (data.val().uid == this.state.user_uid && data.val().raise) {
            this.setState({raise: false });
            this.setState({raise_disable: false});
            this.setState({ listModalOpen: true, listModalPurpose: "loading" })
            this.janus_restart_helper(false)
          }
        })
        const groupRef = database.ref(`/${config.FIREBASE_BASE}/${this.state.conference_id}/group`);
        const groupObj = (await groupRef.once('value')).val()
        const groupArray = groupObj ? Object.keys(groupObj).map((key) => {return groupObj[key]}) : []
        groupArray.map((value,index) => {
          if (value.uid == this.state.user_uid) {
            this.setState({ group: value.group })
          }
        })
        groupRef.on('child_added', (data) => {
          if (data.val().uid == this.state.user_uid ) {
            if (this.state.group != data.val().group ) {
              this.setState({ group: data.val().group })
              var break_join
              if(data.val().group != 0){
                break_join = true
              }else{
                break_join = false
              }
              this.janus_restart_helper(break_join)
            }
          }
          this.props.addGroupUser(data.val())
        })
        groupRef.on('child_changed', (data) => {
          if (data.val().uid == this.state.user_uid ) {
            if (this.state.group != data.val().group ) {
              this.setState({ group: data.val().group })
              var break_join
              if(data.val().group != 0){
                break_join = true
              }else{
                break_join = false
              }
              this.janus_restart_helper(break_join)
            }
          }
          this.props.updateGroupUser(data.val())
        })
        groupRef.on('child_removed', (data) => {
          this.props.deleteGroupUser(data.val())
        })
        const chatRef = database.ref(`/${config.FIREBASE_BASE}/${this.state.conference_id}/chat`)
        var chat = {}
        for (var i = 100 - 1; i >= 0; i--) {
          chat[i]=[]
        }
        this.setState({ chat: chat })
        chatRef.on('child_added', (data) => {
          var chat = this.state.chat
          var data_temp = data.val()
          chat[data_temp.group].push(data_temp)
          this.setState({ notify_count:  this.state.notify_count + 1})
          this.setState({ chat: chat })
        })
      }catch(err){
        alert("接続エラー！再リロードしてください。")
        isSentry(err)
        window.location.reload()
      }
      this.janusStart()
      this.setState({initialize: true})
    }
  }

  changeAudioOutPut = (sinkId) => {
    const element = document.querySelector('video');
    if (typeof element.sinkId !== 'undefined') {
      element.setSinkId(sinkId)
        .then(() => {
          console.log(`Success, audio output device attached: ${sinkId}`);
        })
        .catch(err => {
          if (err.name === 'SecurityError') {
            console.log(`You need to use HTTPS for selecting audio output device: ${err}`)
          }
          const message = "Audio changeAudioOutPut() failed"
          isSentryBreadcrumbs(err,message)
         // console.error(errorMessage);
          // Jump back to first output device in the list as it's the default.
          // audioOutputSelect.selectedIndex = 0;
        });
    } else {
      console.warn('Browser does not support output device selection.');
    }
  }

  handleChat=(text, time, announce )=>{
    if(!isWebinar()){ // P2P chat
      try{
        queue.add(() => new Promise(async (resolve) => {
          var canvas = (window.canvas = document.getElementById('canvas2'));
          var video = document.getElementById('myvideo0')
          if(video){
            canvas.width = 50;
            canvas.height = 50;
            canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
            var type = 'image/png;base64';
            canvas = document.getElementById('canvas2').toDataURL(type);
            var base64Data = canvas.split(',')[1];
            var data = window.atob(base64Data);
            var buff = new ArrayBuffer(data.length);
            var arr = new Uint8Array(buff);
            var blob, i, dataLen;
            for (i = 0, dataLen = data.length; i < dataLen; i++) {
              arr[i] = data.charCodeAt(i);
            }
            blob = new Blob([arr], { type: type });
          }
          else{
            var base64Data = "";
          }
          this.socket.emit('chat', {
            roomName: this.roomName,
            base64Data: base64Data,
            text: text,
            name: this.state.name,
            time: time,
            user_uid: this.state.user_uid
          }); 
          return resolve()
        }))
      }
      catch(error){
       const message = "chat handleChat() failed"
       isSentryBreadcrumbs(error,message)
      } 
    }else{
      if (!announce) {
        var chatRef = database.ref(`/${config.FIREBASE_BASE}/${this.state.conference_id}/chat`)
        var newChatRef = chatRef.push();
        newChatRef.set({
          text: text,
          time: time,
          role: this.state.role,
          name: this.state.name,
          group: this.state.group,
          user_uid: this.state.user_uid,
          user_id: this.state.user_id,
          direct: this.state.direct
        });
        this.setState({chat_value: ""});
      }else{
        var chatRef = database.ref(`/${config.FIREBASE_BASE}/${this.state.conference_id}/chat`)
        var newChatRef = chatRef.push();
        newChatRef.set({
          text: text,
          time: time,
          role: this.state.role,
          name: this.state.name,
          group: 0,
          user_uid: this.state.user_uid,
          user_id: this.state.user_id,
          direct: this.state.direct
        });
        this.props.main.tableList.map((value,index) => {
          var newChatRef = chatRef.push();
          newChatRef.set({
            text: text,
            time: time,
            role: this.state.role,
            name: this.state.name,
            group: value.group,
            user_uid: this.state.user_uid,
            user_id: this.state.user_id,
            direct: this.state.direct
          });
        })
      }
    }
  }
  hangupConf = () => { // P2P hangup
    if(isWebinar()){
      if( this.state.conference_name == "prod1-workshop.tokyo" || this.state.conference_name == "prod2-workshop.tokyo" || this.state.conference_name == "test1-webrtc-dev1.freshvoice.asia" || this.state.conference_name == "test2-webrtc-dev1.freshvoice.asia"  ){ // debug
        console.log("no op")
      }else{
        hangupConf(this.state.room).then(x => {})
        database.ref(`/${config.FIREBASE_BASE}/${this.state.conference_id}/mode`)
        .update({index: "end"})
      }
      this.setState({hangup_modalIsOpen: false});
    }else{
      window.location = "/"
    }
  }
  createTable = (tableName) => {
    var index_max = 1
    this.props.main.tableList.map((value,index) => {
      if (index_max < value.group ) {
        index_max = value.group
      }
    })
    database.ref(`/${config.FIREBASE_BASE}/${this.state.conference_id}/table/${index_max + 1}`).set({ name: tableName, group: index_max + 1})
  }
  editTable = (tableName, group) => {
    database.ref(`/${config.FIREBASE_BASE}/${this.state.conference_id}/table/${group}`).update({ name: tableName })
  }
  deleteTable = (group) => {
    database.ref(`/${config.FIREBASE_BASE}/${this.state.conference_id}/table/${group}`).remove()
  }
  randomHandle = (num) => {
    var cost={}
    this.props.main.tableList.map((table) => {
      cost[table["group"]]=0
    })
    var remoteList = this.props.main.remoteList
    UTIL.shuffle(remoteList)
    remoteList.map((user) => {
      var assign = true
      this.props.main.tableList.map((table) => {
        if (cost[table["group"]] < num && assign && user.role == "student") {
          cost[table["group"]] += 1
          assign = false
          database.ref(`/${config.FIREBASE_BASE}/${this.state.conference_id}/group/${user.uid}`).update({ uid: user.uid, name: user.name, group: table["group"], speak: false, user_id: user.user_id, role: this.state.role })
        }
      })
    })
  }
  redirectToBreakoutMode = () => {
    database.ref(`/${config.FIREBASE_BASE}/${this.state.conference_id}/mode`).update({index: "breakout"});
  }
  redirectToSeminarMode = () => {
    database.ref(`/${config.FIREBASE_BASE}/${this.state.conference_id}/mode`).update({index: "seminar"});
  }
  joinVideo=(uid, name, group, user_id, role, direct)=> {
    try{
    var roomMemberNum = ( typeof this.props.main.groupListObj[group] != "undefined" ) ? (this.props.main.groupListObj[group].length) : (0)
    if (roomMemberNum < 6 || group == 0 ) {
      database.ref(`/${config.FIREBASE_BASE}/${this.state.conference_id}/group/${uid}`).update({
        uid: uid,
        name: name,
        group: group,
        speak: false,
        user_id: user_id,
        role: role,
        direct: direct,
      })
    }else{
      this.setState({
        snackbarOpen: true,
        snackbarMessage: "room full"
      });
    }
  }
  catch(error){
    const message = "video joinVideo() failed"
    isSentryBreadcrumbs(error,message)
  }
  }
  onHear = ( group, hear ) => {
    try{
    const hear_temp = this.state.hear
    hear_temp[group] = hear
    this.setState({ hear: hear_temp});
    this.props.updateHear(group, hear)
  }
  catch(error){
    const message = "Hear onHear() failed"
    isSentryBreadcrumbs(error,message)
  }
  }
  handleOptionChange =  (changeEvent) => {
    this.setState({
      selectedOption: changeEvent.target.value
    });
  }
  notify_count_reset =  () => {
    this.setState({
      notify_count: 0
    });
  }
  handleOpenDrawer () {
    this.setState({ isOpenDrawer: !this.state.isOpenDrawer })
  }

  handleCloseDrawer () {
    this.setState({ isOpenDrawer: false })
  }

  getAudioMuteStateFromRemoteUser(remote_user) {
    let audioMute = false
    let user_uid;

    if (isWebinar()) {
      if (remote_user.name.match(/:/)) {
        user_uid = md5(remote_user.name.split(/:/)[1])
      } else {
        user_uid = md5(remote_user.name)
      }
    } else {
      user_uid = remote_user.id
    }
    if (this.state.databaseMembers[user_uid]
      && this.state.databaseMembers[user_uid].audio === false) {
        audioMute = true
      }

    if (remote_user.name === 'your_view') {
      audioMute = this.state.muteAudio
    }

    return audioMute
  }

  getVideoMuteStateFromRemoteUser(remote_user) {
    let videoMute = false
    let user_uid;

    if (isWebinar()) {
      if (remote_user.name.match(/:/)) {
        user_uid = md5(remote_user.name.split(/:/)[1])
      } else {
        user_uid = md5(remote_user.name)
      }
    } else {
      user_uid = remote_user.id
    }
    videoMute = this.state.databaseMembers[user_uid] && this.state.databaseMembers[user_uid].video === false

    if (remote_user.name === 'your_view') {
      videoMute = this.state.muteVideo
    }

    return videoMute
  }
  render () {
    const notificationStyle = {
      NotificationItem: {
        DefaultStyle: {
          fontSize: '2vw',
          height: "4vw",
          width: '50vw',
          right: "20vw"
        }
      }
    }
    var array = (this.props.main.tableList) ? ( this.props.main.tableList.filter(table => table["group"] === this.state.group) ) : ([])
    array[0] = (array[0]) ? (array[0]) : ({name: "Breakout Room"})
    if (!this.state.initialize) {
      return (
        <div>
        <NotificationSystem ref={this.notificationSystem}  style={notificationStyle}/>
        <LoggedInLayout
          isWebinar={isWebinar()}
          init={true}
          location={this.props.location}
          mode={this.state.mode}
          tableName={"Freshvoice"}
          user_id={this.state.user_id}
          name={this.state.name}
          email={this.state.email}
          role={this.state.role}
          sessionsPremiumRoom={this.state.sessionsPremiumRoom}
          />
        <Background className='w-100 h-100'>
          <Top />
          <Bottom />
          <Mask />
        </Background>
        { !this.state.listModalOpen && <div >
        <Dialog contentStyle={{ width: 600 }} bodyStyle={{ padding: 30 }} open={true} >
         <div className='flex justify-between items-center'>
          <ALertHeaderText>
            {this.state.conference_name}
          </ALertHeaderText>
        </div>
        <div className='mb4'>
          <TextField
            ref={(input) => { this.nameInput = input }}
            errorText={(this.state.nameError) ? (<FormattedMessage id='main.requiredNameField' />) : null}
            hintText={(<FormattedMessage id='main.yourName' />)}
            value={this.state.name}
            onChange={(e)=>{
              this.setState({name: e.target.value})
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                this.onEnterRoom(this.state.anonymous)
              }
            }}
            floatingLabelText={(<FormattedMessage id='main.yourNameFloating' />)}
            fullWidth
          />
        </div>
        <div className='mb4 flex items-center justify-between'>
          <RadioButtonGroup
            onChange={this.handleOptionChange}
            valueSelected={this.state.selectedOption}
            name='shipSpeed'
            defaultSelected={'teacher'}
            className='w-90'
            style={{fill: 'red'}}>
            <RadioButton
              value='teacher'
              label={(<FormattedMessage id='main.teacher' />)}
              iconStyle={{fill: '#45CE90'}}
              uncheckedIcon={<UncheckedRadioButton style={{fill: '#6B7C93'}} />}
              style={{paddingBottom: '1rem'}}
              labelStyle={{color: '#6B7C93'}}
              />
            <RadioButton
              value='student'
              label={(<FormattedMessage id='main.student' />)}
              iconStyle={{fill: '#45CE90'}}
              uncheckedIcon={<UncheckedRadioButton style={{fill: '#6B7C93'}} />}
              style={{paddingBottom: '1rem'}}
              labelStyle={{color: '#6B7C93'}}
              />
          </RadioButtonGroup>
        </div>
         <div className='flex justify-end mb4'>
          <RaisedButton
            className='ml3'
            backgroundColor='#FCCE42'
            type='submit'
            onClick={() => {this.onEnterRoom(this.state.anonymous)}}
            label={"入室"} />
        </div>
        </Dialog>
        </div> }
        <Modal
          purpose={this.state.listModalPurpose}
          open={this.state.listModalOpen}
          isWebinar={isWebinar()}
        />
        </div>
      )
    }

    const videoRemoteList = this.props.main.videoRemoteList
    if ( this.state.mode == "breakout" && !this.state.break_join ) {
      return (
        <div>
          <NotificationSystem ref={this.notificationSystem}  style={notificationStyle}/>
          <LoggedInLayout
            direct={this.state.direct}
            location={this.props.location}
            mode={this.state.mode}
            tableName={array[0].name}
            user_id={this.state.user_id}
            name={this.state.name}
            email={this.state.email}
            role={this.state.role}
            confName={this.state.conference_name}
            sessionsPremiumRoom={this.state.sessionsPremiumRoom}
            />
          <BreakOutMode
            isWebinar={isWebinar()}
            location={this.props.location}
            remoteList={this.props.main.remoteList}
            handleListClick={this.props.handleListClick}
            handleChat={this.handleChat}
            randomHandle={this.randomHandle}
            createTable={this.createTable}
            deleteTable={this.deleteTable}
            user_name={this.state.name}
            user_uid={this.state.user_uid}
            user_id={this.state.user_id}
            tableList={this.props.main.tableList}
            groupListObj={this.props.main.groupListObj}
            groupList={this.props.main.groupList}
            chat={this.state.chat[this.state.group]}
            redirectToSeminarMode={this.redirectToSeminarMode}
            editTable={this.editTable}
            listModalOpen={this.state.listModalOpen}
            listModalPurpose={this.state.listModalPurpose}
            joinVideo={this.joinVideo}
            role={this.state.role}
            snackbarOpen={this.state.snackbarOpen}
            snackbarMessage={this.state.snackbarMessage}
            handleRequestClose={this.handleRequestClose}
            onHear={this.onHear}
            hear={this.state.hear}
            direct={this.state.direct} />
          <div className="absolute" style={{ top: '7vh' }}>
            {videoRemoteList && videoRemoteList.map((remote_user,index) => {
              if (!remote_user.full) {
                return null;
              }
              return (
                <VideoView
                  isWebinar={isWebinar()}
                  isOpenDrawer={this.state.isOpenDrawer}
                  style={{zIndex: 1}}
                  key={remote_user["key"]}
                  index={index}
                  remote_user={remote_user}
                  audioMuteToggle={this.audioMuteToggle}
                  switchFullScreen={this.switchFullScreen}
                  break_join={this.state.break_join}
                  mode={this.state.mode}
                  isSharing={this.state.screen_publish_state}
                   />
              )})}
          </div>
          <div style={{
            width: 'calc(10vw + 2px)',
            height: isWebinar() ?  'calc( 94vh - 20vh - 65px - 30px)' : 'calc( 93vh - 20vh - 65px - 30px)',
            margin: '20vh 0 0 1vw',
            overflowX: 'hidden',
            overflowY: 'scroll',
          }}>
            {videoRemoteList && videoRemoteList.map((remote_user,index) => {
              if (remote_user.full) {
                return null;
              }
              return (
                <VideoView
                  isWebinar={isWebinar()}
                  isOpenDrawer={this.state.isOpenDrawer}
                  style={{zIndex: 1}}
                  key={remote_user["key"]}
                  index={index}
                  remote_user={remote_user}
                  audioMuteToggle={this.audioMuteToggle}
                  switchFullScreen={this.switchFullScreen}
                  break_join={this.state.break_join}
                  mode={this.state.mode}
                  isSharing={this.state.screen_publish_state}
                />
              )})}
          </div>
        </div>
      );
    }
    return (
      <Background className='w-100 h-100 mobileNotification videoMobile-Height'>
        <NotificationSystem ref={this.notificationSystem} style={notificationStyle}/>
        <div className="flex flex-column">
        {!isWebinar() && <canvas id="canvas2" className="br-100" height="0" width="0" hidden />}
        { this.state.buttonDisplay && <LoggedInLayout
          direct={this.state.direct}
          location={this.props.location}
          mode={this.state.mode}
          tableName={array[0].name}
          user_id={this.state.user_id}
          name={this.state.name}
          email={this.state.email}
          role={this.state.role}
          confName={this.state.conference_name}
          sessionsPremiumRoom={this.state.sessionsPremiumRoom}
           />
        }
        <div className=' w-100 hAuto floatbtnMobile' style={checkMobile() ? {height: '8vh', bottom: '5vh', zIndex: 150,position:'absolute'} : {} } >
          <div>
            <FloatingButtons
              isCountStart={this.state.isCountStart}
              sessionsPremiumRoom={this.state.sessionsPremiumRoom}
              isWebinar={isWebinar()}
              notify_count={this.state.notify_count}
              location={this.props.location}
              secondsElapsed={this.props.main.secondsElapsed}
              notify_count_reset={this.notify_count_reset}
              handleListClick={this.handleListClick}
              remoteList={this.props.main.remoteList}
              raiseList={this.props.main.raiseList}
              role={this.state.role}
              user_uid={this.state.user_uid}
              user_name={this.state.name}
              user_id={this.state.user_id}
              joinVideo={this.joinVideo}
              mode={this.state.mode}
              group={this.state.group}
              groupListObj={this.props.main.groupListObj}
              groupList={this.props.main.groupList}
              break_join={this.state.break_join}
              muteVideo={this.state.muteVideo}
              muteAudio={this.state.muteAudio}
              buttonDisplay={this.state.buttonDisplay}
              publish_state_default={this.state.publish_state_default}
              screen_publish_state={this.state.screen_publish_state}
              raise={this.state.raise}
              handleChat={this.handleChat}
              chat={this.state.chat[this.state.group]}
              mobile={this.state.mobile}
              direct={this.state.direct}
              history={this.props.api.history}
              isOpenDrawer={this.state.isOpenDrawer}
              handleOpenDrawer={() => this.handleOpenDrawer()}
              handleCloseDrawer={() => this.handleCloseDrawer()}
              isRecording={this.state.isRecording}
              recordingTime={this.state.recordingTime}
            />
          </div>
        </div>
        <Snackbar
          style={{ left: 200, bottom: 30 }}
          open={this.state.snackbarOpen}
          message={this.state.snackbarMessage}
          action='dismiss'
          onActionClick={this.handleRequestClose}
          autoHideDuration={4000}
          onRequestClose={this.handleRequestClose} />
        <Modal
          redirectToBreakoutMode={this.redirectToBreakoutMode}
          purpose={this.state.listModalPurpose}
          open={this.state.listModalOpen}
          handleClose={this.handleListModalClose}
          handleDeviceSave={this.handleDeviceSave}
          isWebinar={isWebinar()}
          snackbarOpen={this.handleTouchTap}
          getDeviceList={this.getDeviceList}
          audio_device_value_index={this.state.audio_device_value_index}
          audio_output_device_value_index={this.state.audio_output_device_value_index}
          video_device_value_index={this.state.video_device_value_index}
          audio_device={this.state.audio_device}
          audio_output_array={this.state.audio_output_array}
          changeAudioOutPut={this.changeAudioOutPut}
          video_device={this.state.video_device}
          bitrate_index={this.state.bitrate_index}
          hangupConf={this.hangupConf}
          redirectToBreakout={this.redirectToBreakout}
          disabledVideoPermission= {this.state.disabledVideoPermission}
          disabledAudioPermission= {this.state.disabledAudioPermission}
          pathname={this.props.api.history.location.pathname}
          />
          <div className="absolute" style={{ top: isWebinar() ? '6vh' : '7vh' }}>
            {videoRemoteList && videoRemoteList.map((remote_user,index) => {
              if (!remote_user.full) {
                return null;
              }

              return (
                <VideoView
                  isWebinar={isWebinar()}
                  isOpenDrawer={this.state.isOpenDrawer}
                  style={{zIndex: 1}}
                  key={remote_user["key"]}
                  index={index}
                  remote_user={remote_user}
                  audioMuteToggle={this.audioMuteToggle}
                  switchFullScreen={this.switchFullScreen}
                  break_join={this.state.break_join}
                  mode={this.state.mode}
                  muteAudio={this.getAudioMuteStateFromRemoteUser(remote_user)}
                  muteVideo={this.getVideoMuteStateFromRemoteUser(remote_user)}
                  isSharing={this.state.screen_publish_state}
                />
              )})}
          </div>
          <div className="clientVideoView" style={{
            width: 'calc(10vw + 2px)',
            height: 'calc( 100vh - 20vh - 65px - 30px)',
            margin: '4vh 0 0 1vw',
            overflowX: 'hidden',
            overflowY: 'scroll',

          }}>
            {videoRemoteList && videoRemoteList.map((remote_user,index) => {
              if (remote_user.full) {
                return null;
              }

              return (
                <VideoView
                  isWebinar={isWebinar()}
                  isOpenDrawer={this.state.isOpenDrawer}
                  style={{zIndex: 1}}
                  key={remote_user["key"]}
                  index={index}
                  remote_user={remote_user}
                  audioMuteToggle={this.audioMuteToggle}
                  switchFullScreen={this.switchFullScreen}
                  break_join={this.state.break_join}
                  mode={this.state.mode}
                  muteAudio={this.getAudioMuteStateFromRemoteUser(remote_user)}
                  muteVideo={this.getVideoMuteStateFromRemoteUser(remote_user)}
                  isSharing={this.state.screen_publish_state}
                />
              )})}
          </div>
      </div>
      </Background>
    );
  }
}
export default SeminarMode;



// WEBPACK FOOTER //
// ./src/routes/SeminarMode/SeminarMode.js